import * as React from 'react';
import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';

import { checkBoxWithBlueBorder } from "../StyledComponent"
import { FORM_NAMES_KEY } from '../../SPOC/constant';


export const CommsSelectCheckBox = ({setValue, getValue, name, watch, SPOCComms, DoctorComms, AppointmentsComms, setDoctorComms, setSPOCComms, setAppointmentsComms, setCommsPrefEnabled, setCommsPrefChanged}) => {
  const watchComms = watch('comms');
  const [commsEnable, setCommsEnable] = useState(false);
  const [commsMasterList, setCommsMasterList] = useState({
  })

  useEffect(() => {
    //setting the master list)
    if(!(getValue(FORM_NAMES_KEY.SPOC)|| getValue(FORM_NAMES_KEY.DOCTOR)|| getValue(FORM_NAMES_KEY.APPOINTMENT))) 
     { 
      setCommsEnable(false);
      setValue(FORM_NAMES_KEY.COMMSELECTION, true);
     }
    else {
      setCommsEnable(true);
    }
   setCommsMasterList({
      'SPOC': getValue(FORM_NAMES_KEY.SPOC),
      'Doctor': getValue(FORM_NAMES_KEY.DOCTOR),
      'Appointments': getValue(FORM_NAMES_KEY.APPOINTMENT),
    });

    setSPOCComms({
    'Email': getValue(FORM_NAMES_KEY.SPOC_UPDATE_EMAIL),
    'WhatsApp': getValue(FORM_NAMES_KEY.SPOC_UPDATE_WHATSAPP),
    'SMS': getValue(FORM_NAMES_KEY.SPOC_UPDATE_SMS),
    });

    setDoctorComms({
      'Email': getValue(FORM_NAMES_KEY.DOCTOR_UPDATE_EMAIL),
      'WhatsApp': getValue(FORM_NAMES_KEY.DOCTOR_UPDATE_WHATSAPP),
      'SMS': getValue(FORM_NAMES_KEY.DOCTOR_UPDATE_SMS),
    })

    setAppointmentsComms({
      'Email': getValue(FORM_NAMES_KEY.APPOINTMENT_UPDATE_EMAIL),
      'WhatsApp': getValue(FORM_NAMES_KEY.APPOINTMENT_UPDATE_WHATSAPP),
      'SMS': getValue(FORM_NAMES_KEY.APPOINTMENT_UPDATE_SMS),
    })
  }, [watchComms]); 


  const handleCommsChange = (event) => {
    setCommsEnable(JSON.parse(event.target.value));
    const comsPrefEnabled = JSON.parse(event.target.value);
    setCommsPrefEnabled(comsPrefEnabled);
    setCommsPrefChanged(true)
    if(!JSON.parse(event.target.value)){
      setSPOCComms({
        'Email': false,
        'WhatsApp': false,
        'SMS': false,
      });
      setDoctorComms({
        'Email': false,
        'WhatsApp': false,
        'SMS': false,
      });
      setAppointmentsComms({
        'Email': false,
        'WhatsApp': false,
        'SMS': false,
      });
    }
    setValue('commsPrefChanged',true,{shouldDirty:true})
  };

  const CommsOptionCheckList = ({commsOptions, setCommsOptions, commsType}) => {

    const isCommsTypeEnbaled = (options) =>{
      if(options.SMS || options.WhatsApp || options.Email){
        return true;
      }
      return false
    }

    const handleSmsChange = (event) => {
      const newCommsOptions = {...commsOptions};
      newCommsOptions.SMS = event.target.checked;
      newCommsOptions.commsType = isCommsTypeEnbaled(newCommsOptions);
      setCommsOptions(newCommsOptions);
      setValue('commsPrefChanged',true,{shouldDirty:true})
      setCommsPrefChanged(true)
    };

    const handleEmailChange = (event) => {
      const newCommsOptions = {...commsOptions};
      newCommsOptions.Email = event.target.checked;
      newCommsOptions.commsType = isCommsTypeEnbaled(newCommsOptions);
      setCommsOptions(newCommsOptions);
      setValue('commsPrefChanged',true,{shouldDirty:true})
      setCommsPrefChanged(true)
    };

    const handleWhatsAppChange = (event) => {
      const newCommsOptions = {...commsOptions};
      newCommsOptions.WhatsApp = event.target.checked;
      newCommsOptions.commsType = isCommsTypeEnbaled(newCommsOptions);
      setCommsOptions(newCommsOptions);
      setValue('commsPrefChanged',true,{shouldDirty:true})
      setCommsPrefChanged(true);
    };


    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', ml: 3 }}>
        <FormControlLabel
          label="Email"
          control={<Checkbox checked={commsOptions.Email} onChange={handleEmailChange} sx={checkBoxWithBlueBorder} />}
        />
        <FormControlLabel
          label="WhatsApp"
          control={<Checkbox checked={commsOptions.WhatsApp} onChange={handleWhatsAppChange} sx={checkBoxWithBlueBorder} />}
        />
        <FormControlLabel
          label="SMS"
          control={<Checkbox checked={commsOptions.SMS} onChange={handleSmsChange} sx={checkBoxWithBlueBorder} />}
        />
      </Box>
    );
  }


  const CommsMasterCheckBox = ({
    label, 
    commsType,
    isEnabled, 
    setCommsOptions, 
    commsOptions}) => {
      const handleChangeMasterCheckBox = (event) => {
        const isChecked = event.target.checked;
        const newCommsOptions = {...commsMasterList};
        newCommsOptions[commsType] = isChecked;
        setCommsMasterList(newCommsOptions);

        if(isChecked)
        {
          setCommsOptions({ 
            commsType:true,
            'Email':true,
            'WhatsApp':true,
            'SMS':true,
          });
        }
        else {
          setCommsOptions({
            commsType:false, 
            'Email':false,
            'WhatsApp':false,
            'SMS':false,
          });
        }
        setValue('commsPrefChanged',true,{shouldDirty:true}) 
        setCommsPrefChanged(true)
      };


    return (
      <div className="flex flex-col justify-start gap-2">
        <FormControlLabel
          disabled={!isEnabled}
          label={label} //
          control={
            <Checkbox
              checked={isEnabled && commsMasterList [commsType]}
              onChange={handleChangeMasterCheckBox}
              sx={checkBoxWithBlueBorder}
            />
          }
        />
        {isEnabled && commsMasterList [commsType] && <CommsOptionCheckList commsType={commsType} commsOptions={commsOptions} setCommsOptions={setCommsOptions} />}
      </div>
    )
  }

  return (
    <div className='flex flex-col gap-4 justify-start '>
      <FormControl className='flex flex-row'>
        <RadioGroup
          aria-labelledby="demo-controlled-radio-buttons-group"
          name="controlled-radio-buttons-group"
          value={commsEnable}
          onChange={handleCommsChange}
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: '0.5rem'
          }}
        >
          <FormControlLabel value={true} control={<Radio />} label="Yes" />
          <FormControlLabel value={false} control={<Radio />} label="No" />
        </RadioGroup>
      </FormControl>
      <CommsMasterCheckBox label="Send SPOC List related Notifications" commsType="SPOC" isEnabled={commsEnable} setCommsOptions={setSPOCComms} commsOptions={SPOCComms} />
      <CommsMasterCheckBox label="Send ‘Manage Doctors’ related Notifications" commsType={"Doctor"} isEnabled={commsEnable} setCommsOptions={setDoctorComms} commsOptions={DoctorComms} />
      <CommsMasterCheckBox label="Send ‘Appointments’ related Notifications" commsType={"Appointments"} isEnabled={commsEnable} setCommsOptions={setAppointmentsComms} commsOptions={AppointmentsComms} />
    </div>
  );
}